import React, {Component} from 'react';


import {Field} from 'redux-form'
import {locale} from '../locale/AppLocale'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
// import ReactTooltip from 'react-tooltip'
import Loader from '../Components/Loader'
import ProductInput from "../Components/ProductInput"
import ProductVariants from "../Components/ProductVariants"
import {
    validateBasics,
    validateAttributesGroup,
    validateVariants,
    validateSellingProps,
    validatePrimarySellingProps,
    publishErrors
} from  '../Helpers/ValidateProduct'
import {GetEntityAttribute} from "../Helpers/Entity";


class ProductAttributesWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasTabs: false,
            totalSteps: 0,
            current: 1,
            next: 2,
            prev: 0,
            currentStepTotalErrors: 0,
            stepsErrors: [],
            validSteps: [],
            stepHeight: {},
        };
        this.changeStep = this.changeStep.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrev = this.onClickPrev.bind(this);
        this.isDisabledNext = this.isDisabledNext.bind(this);
        this.isDisabledPrev = this.isDisabledPrev.bind(this);
        this.isLastStep = this.isLastStep.bind(this);
        this.beforeChangeStep = this.beforeChangeStep.bind(this);
        this.getStepErrorsCount = this.getStepErrorsCount.bind(this);
        this.onValidateError = this.onValidateError.bind(this);
        this.renderFieldElement = this.renderFieldElement.bind(this);

        this.validSteps = {};
    }

    componentDidMount() {

        let hasTabs = false;

        this.props.attributes.forEach((group, wizardStep) => {
            let groupIndex = wizardStep + 1;
            if(groupIndex !== 1){
                if(group.properties.length > 3){
                    hasTabs = true;
                }
            }
        });
        this.setState({totalSteps: this.props.attributes.length, hasTabs: hasTabs});
    }

    render() {
        return (
            <div className="wizard">
                <div className="panel-1--body no-pt no-pb">
                    <div className="inner-content-width">
                        {this.renderHeader()}
                        {this.renderBody()}
                    </div>
                </div>
                <div className="clearfix"></div>
                {this.renderFooter()}
                <div className="clearfix"></div>
            </div>
        )
    }

    getStepErrorsCount(stepId) {
        let errors = this.state.stepsErrors;
        let index = errors.findIndex((error) => {
            return error.step === stepId;
        });
        if (index === -1) {
            return 0;
        }
        return errors[index].total || 0;
    }

    getStepNavigationClass(stepId) {
        let stepClass = '';
        if (this.state.current === stepId) {
            stepClass += ' active ';
        }
        if (this.getStepErrorsCount(stepId)) {
            stepClass += ' has-error ';
        }
        return stepClass;
    }

    renderHeader() {
        return (
            this.state.hasTabs && <div className="wizard--header">
                <ul>
                    {this.props.attributes.map((group, wizardStep) => {
                        let stepId = wizardStep + 1;
                        return (
                            <li key={stepId}>
                                <Link to={`#` + stepId}
                                      className={this.getStepNavigationClass(stepId)}
                                      onClick={(e) => {
                                          e.preventDefault();
                                          this.changeStep(stepId)
                                      }}>
                                    {GetEntityAttribute(group,'title') + (this.getStepErrorsCount(stepId) > 0 ? (' (' + this.getStepErrorsCount(stepId) + ') ') : ('') )}
                                </Link>
                            </li>)
                    })}
                </ul>
            </div>
        )
    }

    onChangeField(field, event, value) {
        // console.log('onChangeField',field, event, value)
        if (this.props.withVariants === true && field.is_variant) {
            this.props.requireVariantUpdate(true);
        }
    }

    renderFieldElement(field, groupIndex, index) {
        // let tooltipKey = 'product_tootltip_' + field.name;
        return (


            <div key={index} ref={groupIndex + `-` + field.name}>

                <Field
                    type={field.data_type}
                    name={field.name}
                    id={field.name}
                    component={ProductInput}
                    label={GetEntityAttribute(field,'title')}
                    placeholder={GetEntityAttribute(field,'title')}
                    field={field}
                    disabled={this.props.disabled}
                    onChange={this.onChangeField.bind(this, field)}
                />
                {/*
                 <div key={index} ref={groupIndex + `-` + field.name}
                 className="tooltip-field"
                 data-scroll-hide={true}
                 data-event="click"
                 data-event-off="focusout"
                 data-for={tooltipKey}
                 data-tip=''
                 data-place="left"
                 data-effect="solid"
                 data-multiline="true"
                 >
                 <Field
                 type={field.data_type}
                 name={field.name}
                 id={field.name}
                 component={ProductInput}
                 label={field.title_ar}
                 placeholder={field.title_ar}
                 field={field}
                 disabled={this.props.disabled}
                 onChange={this.onChangeField.bind(this, field)}
                 />
                 <ReactTooltip
                 id={tooltipKey}>{locale.get(tooltipKey, field.title_ar)}</ReactTooltip>
                 </div>
                 */}
            </div>

        );

    }

    renderBody() {

        return (
            <div className={` wizard--body ` + (!this.state.hasTabs ? ' wizard--body--full ' : '')  }>
                { this.props.attributes.length === 0 && this.props.subView && this.props.subView}
                {this.props.attributes.map((group, wizardStep) => {
                    let groupIndex = wizardStep + 1;
                    return (
                        <div key={groupIndex} ref={`wizard--body-item-` + groupIndex}
                             className={`wizard--body-item ` +( (this.state.current === groupIndex || !this.state.hasTabs) ? ' wizard--body-item--active' : ' wizard--body-item--hidden')}>
                            {group.properties.map((field, index) => {
                                return (this.renderFieldElement(field, groupIndex, index));
                            })}

                            { groupIndex === this.props.attributes.length && this.props.subView && this.props.subView}
                        </div>)
                })}

            </div>
        );
    }

    onClickNext() {
        if (this.isDisabledNext()) {
            return;
        }
        let nextState = this.state.current + 1;
        this.changeStep(nextState);
    }

    onClickPrev() {
        let prevState = this.state.current - 1;
        this.changeStep(prevState);
    }

    changeStep(newStepId) {
        if (this.state.current === newStepId) {
            return;
        }
        let validate;
        if(newStepId < this.state.current){
            validate = true;
        }else{
            validate = this.beforeChangeStep(this.state.current) === true
            if(newStepId - this.state.current > 1){
                for(let i = this.state.current; i <= newStepId;i++){
                    validate = validate && this.beforeChangeStep(i)
                }
            }
        }

        if (validate) {
            this.goToStep(newStepId);
        }
    }

    goToStep(stepId) {
        this.setState({
            current: stepId,
            next: stepId + 1,
            prev: stepId - 1,
        });
    }

    beforeChangeStep(currentStep) {
        let errors = this.validateCurrentStep(currentStep);
        return !errors || Object.keys(errors).length === 0;
    }

    isDisabledNext() {
        if (this.state.current < (this.state.totalSteps )) {
            return false
        }
        return true
    }

    isDisabledPrev() {
        if (this.state.current > 1) {
            return false
        }
        return true
    }

    isLastStep() {
        return this.state.current === (this.state.totalSteps);
    }

    renderFooter() {

        return (
            <div className="wizard--footer">
                {this.props.withVariants === true ? (
                        <div className="panel-1--body no-pt">
                            <ProductVariants
                                variants={this.props.variants || {}}
                                dispatch={this.props.dispatch}/>
                        </div>
                    ) : ('')}

                <div className="panel-1--footer">
                    <Link to={`/${this.props.match.params.businessSlug}/manage`} className="btn btn-2 "
                          disabled={this.props.formActions.submittingForm}>{locale.get('btn_cancel')}</Link>

                    {this.state.hasTabs && this.state.totalSteps > 1 ? (
                            <button type="button" className="btn btn-2" disabled={this.isDisabledPrev()}
                                    onClick={() => {
                                        this.onClickPrev()
                                    }}>{locale.get('btn_prev')}</button>
                        ) : ('')}

                    {this.state.hasTabs && this.state.totalSteps > 1 ? (
                            <button type="button" className="btn btn-2" disabled={this.isDisabledNext()}
                                    onClick={() => {
                                        this.onClickNext()
                                    }}>{locale.get('btn_next')}</button>
                        ) : ('')}

                    { ( (!this.state.hasTabs || this.isLastStep() === true )&& this.props.action === 'create') ? (
                            <button className="btn btn-1" disabled={this.props.formActions.submittingForm}><Loader
                                completed={this.props.formActions.submittingForm === false}/> {locale.get('btn_create_product')}
                            </button>) : (
                            (!this.state.hasTabs || (this.props.action === 'update' && this.state.current === this.state.totalSteps) ) ? (
                                    <button className="btn btn-1"
                                            disabled={this.props.disabled || this.props.formActions.submittingForm}>
                                        <Loader
                                            completed={this.props.formActions.submittingForm === false}/> {locale.get('btn_update')}
                                    </button>) : ('')
                        )}
                </div>
            </div>
        );
    }

    onValidateError(errors, currentStep) {

        let totalErrors = Object.keys(errors).length;

        let stepsErrors = [];

        stepsErrors.push({step: currentStep, total: totalErrors, errors: errors});

        this.setState({stepsErrors: stepsErrors});

        publishErrors(errors)

    }

    validateCurrentStep(currentStep) {

        let stepAttributes = this.props.attributes[(currentStep - 1)];

        // let propNames = stepAttributes.properties.reduce((data, item) => {
        //     data.push(item.name);
        //     data.push(item.name + '_other');
        //     return data
        // }, []);

        let errors = validateBasics(this.props.values, this.props);

        errors = {...errors, ...validateAttributesGroup(this.props.values, stepAttributes)}

        let variants = this.props.selector('variants');

        if (this.props.withVariants === true && variants) {
            let variantsErrors = validateVariants(variants);
            if (Object.keys(variantsErrors).length > 0) {
                errors.variants = variantsErrors
            }


            if(errors.variants && errors.variants.at_least_one_variant){
                errors.at_least_one_variant = locale.get('at_least_one_variant_required')
                delete errors.variants.at_least_one_variant
            }

        }

        if (this.isLastStep()) {
            if(this.props.only_primary){
                errors = {...errors,...validatePrimarySellingProps(this.props.values,this.props)}
            }else{
                errors = {...errors,...validateSellingProps(this.props.values,this.props)}
            }
        }

        this.setState({stepsErrors: []});

        let errorKeys = Object.keys(errors);


        if (errorKeys.length > 0) {
            this.props.throwErrors(errors);
            this.onValidateError(errors, currentStep);
        }

        return errors;
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return ownProps.containerProps;
};


// Maps actions to props
const mapDispatchToProps = (dispatch, ownProps) => {
    return ownProps.containerProps;

};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAttributesWizard);
